/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TaskPriority } from './TaskPriority';
import {
    TaskPriorityFromJSON,
    TaskPriorityFromJSONTyped,
    TaskPriorityToJSON,
    TaskPriorityToJSONTyped,
} from './TaskPriority';
import type { TaskStatus } from './TaskStatus';
import {
    TaskStatusFromJSON,
    TaskStatusFromJSONTyped,
    TaskStatusToJSON,
    TaskStatusToJSONTyped,
} from './TaskStatus';

/**
 * A task associated with a claim
 * @export
 * @interface ClaimTask
 */
export interface ClaimTask {
    /**
     * Unique task ID
     * @type {number}
     * @memberof ClaimTask
     */
    readonly id: number;
    /**
     * ID of the claim this task belongs to
     * @type {number}
     * @memberof ClaimTask
     */
    claimId: number;
    /**
     * ID of the status template that triggered this task (if created from template)
     * @type {number}
     * @memberof ClaimTask
     */
    claimStatusTemplateId?: number | null;
    /**
     * ID of the task template this was created from (if applicable)
     * @type {number}
     * @memberof ClaimTask
     */
    taskTemplateId?: number | null;
    /**
     * Task title
     * @type {string}
     * @memberof ClaimTask
     */
    title: string;
    /**
     * Optional task description
     * @type {string}
     * @memberof ClaimTask
     */
    description?: string | null;
    /**
     * 
     * @type {TaskStatus}
     * @memberof ClaimTask
     */
    status: TaskStatus;
    /**
     * 
     * @type {TaskPriority}
     * @memberof ClaimTask
     */
    priority: TaskPriority;
    /**
     * Optional due date for the task
     * @type {Date}
     * @memberof ClaimTask
     */
    dueDate?: Date | null;
    /**
     * Timestamp when the task was completed
     * @type {Date}
     * @memberof ClaimTask
     */
    readonly completedAt?: Date | null;
    /**
     * ID of the user assigned to this task
     * @type {number}
     * @memberof ClaimTask
     */
    assignedTo?: number | null;
    /**
     * Name of the user assigned to this task
     * @type {string}
     * @memberof ClaimTask
     */
    assignedToName?: string | null;
    /**
     * ID of the user who created this task
     * @type {number}
     * @memberof ClaimTask
     */
    createdBy: number;
    /**
     * 
     * @type {Date}
     * @memberof ClaimTask
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof ClaimTask
     */
    readonly updatedAt: Date;
    /**
     * Claim number associated with the task
     * @type {string}
     * @memberof ClaimTask
     */
    claimNumber?: string | null;
    /**
     * Insured name associated with the claim
     * @type {string}
     * @memberof ClaimTask
     */
    insuredName?: string | null;
    /**
     * Whether the current user can edit this task's claim
     * @type {boolean}
     * @memberof ClaimTask
     */
    readonly canWrite?: boolean;
}



/**
 * Check if a given object implements the ClaimTask interface.
 */
export function instanceOfClaimTask(value: object): value is ClaimTask {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('claimId' in value) || value['claimId'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('priority' in value) || value['priority'] === undefined) return false;
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function ClaimTaskFromJSON(json: any): ClaimTask {
    return ClaimTaskFromJSONTyped(json, false);
}

export function ClaimTaskFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimTask {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'claimId': json['claimId'],
        'claimStatusTemplateId': json['claimStatusTemplateId'] == null ? undefined : json['claimStatusTemplateId'],
        'taskTemplateId': json['taskTemplateId'] == null ? undefined : json['taskTemplateId'],
        'title': json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'status': TaskStatusFromJSON(json['status']),
        'priority': TaskPriorityFromJSON(json['priority']),
        'dueDate': json['dueDate'] == null ? undefined : (new Date(json['dueDate'])),
        'completedAt': json['completedAt'] == null ? undefined : (new Date(json['completedAt'])),
        'assignedTo': json['assignedTo'] == null ? undefined : json['assignedTo'],
        'assignedToName': json['assignedToName'] == null ? undefined : json['assignedToName'],
        'createdBy': json['createdBy'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'claimNumber': json['claimNumber'] == null ? undefined : json['claimNumber'],
        'insuredName': json['insuredName'] == null ? undefined : json['insuredName'],
        'canWrite': json['canWrite'] == null ? undefined : json['canWrite'],
    };
}

export function ClaimTaskToJSON(json: any): ClaimTask {
    return ClaimTaskToJSONTyped(json, false);
}

export function ClaimTaskToJSONTyped(value?: Omit<ClaimTask, 'id'|'completedAt'|'createdAt'|'updatedAt'|'canWrite'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claimId': value['claimId'],
        'claimStatusTemplateId': value['claimStatusTemplateId'],
        'taskTemplateId': value['taskTemplateId'],
        'title': value['title'],
        'description': value['description'],
        'status': TaskStatusToJSON(value['status']),
        'priority': TaskPriorityToJSON(value['priority']),
        'dueDate': value['dueDate'] == null ? undefined : ((value['dueDate'] as any).toISOString()),
        'assignedTo': value['assignedTo'],
        'assignedToName': value['assignedToName'],
        'createdBy': value['createdBy'],
        'claimNumber': value['claimNumber'],
        'insuredName': value['insuredName'],
    };
}

